import { Component, Input } from '@angular/core';

@Component({
  selector: 'app-pagination-component',
  template: `
  <div class="row row-cols-auto justify-content-center justify-content-md-end">
    <div class="col">
      <div class="d-flex align-items-center mb-4">
        <label for="goToPage" class="form-label small fw-normal text-nowrap mb-0 me-2 ">Go to page</label>
        <select class="form-select form-select-sm" id="goToPage" aria-label="Default Select Input" (change)="goToPage($event)">
            <option *ngFor="let pageNumber of numberOfPages" [selected]="pageNumber == parentComponent.page">{{ pageNumber }}</option>
        </select>
      </div>
    </div>

    <div class="col">
      <div class="d-flex align-items-center mb-4">
        <label for="perPage" class="form-label small fw-normal text-nowrap mb-0 me-2 ">Per page</label>
        <select class="form-select form-select-sm" id="perPage" aria-label="Default Select Input" (change)="selectPageSize($event)">
          <option *ngFor="let choice of itemsPerPageChoices" [selected]="choice == parentComponent.pageSize">{{ choice }}</option>
        </select>
      </div>
    </div>

    <div class="col">
    <ngb-pagination class="mb-4" #numPages [(page)]="parentComponent.page" [pageSize]="parentComponent.pageSize" [collectionSize]="collectionSize"
        [boundaryLinks]="true" [ellipses]="false" [maxSize]="4" [rotate]="true" aria-label="Default pagination"  size="sm">
        <ng-template ngbPaginationFirst><span class="material-icons-round icon-sm" aria-hidden="true">first_page</span></ng-template>
        <ng-template ngbPaginationPrevious><span class="material-icons-round icon-sm" aria-hidden="true">chevron_left</span></ng-template>
        <ng-template ngbPaginationNext><span class="material-icons-round icon-sm" aria-hidden="true">chevron_right</span></ng-template>
        <ng-template ngbPaginationLast><span class="material-icons-round icon-sm" aria-hidden="true">last_page</span></ng-template>
        <ng-template ngbPaginationNumber let-page>{{ page }}</ng-template>
      </ngb-pagination>
    </div>
  </div>
  `
})
export class PaginationComponent {

  @Input()
  collectionSize: number;

  @Input()
  parentComponent: any;

  itemsPerPageChoices: number[] = [5, 10, 20];
  page = 1;
  pageSize = 10;

  get numberOfPages(): number[] {
    const max = (this.collectionSize / this.pageSize) + 1;
    const myArray = []
    for (let i = 1; i < max; i++) {
      myArray.push(i)
    }
    return myArray;
  }

  changePagesize(num: number): void {
    this.pageSize = this.pageSize + num;
    this.parentComponent.pageSize = this.pageSize;
  }

  selectPageSize(event) {
    this.pageSize = Number(event.target.value);
    this.parentComponent.pageSize = this.pageSize;
  }

  goToPage(event) {
    this.page = Number(event.target.value);
    this.parentComponent.page = this.page;
  }

}
